"use client";

import React from "react";
import { Star } from "lucide-react";
import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious } from "@/components/ui/carousel";
import { Card, CardDescription, CardFooter, CardHeader } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const testimonials = [{
  author: "Sarah Jenkins",
  car: "Residential Move",
  quote: "Shift made our family move incredibly easy. The team was punctual, handled our piano with extreme care, and finished ahead of schedule. Truly stress-free!"
}, {
  author: "David Chen",
  car: "Office Relocation",
  quote: "Professionalism at its finest. They managed our entire tech setup relocation without a single scratch. The tracking technology kept us informed throughout."
}, {
  author: "Marcus Thompson",
  car: "Local Apartment Move",
  quote: "I've moved five times in ten years, and this was by far the best experience. Transparent pricing and a crew that actually cares about your belongings."
}, {
  author: "Elena Rodriguez",
  car: "Long Distance Move",
  quote: "Moving across states is daunting, but Shift handled the logistics perfectly. Everything arrived intact and the communication was exceptional."
}, {
  author: "Robert Wilson",
  car: "Commercial Warehouse",
  quote: "Efficient, organized, and reliable. They handled our inventory transition with precision. Highly recommend for any business relocation needs."
}];
export default function ClientExperiences() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="222009" id="client-experiences" className="bg-background text-foreground relative overflow-hidden py-24 md:py-32" ref={ref}>
      {}
      <div className="absolute inset-0 z-0 pointer-events-none overflow-hidden opacity-10">
        <div className="absolute top-1/4 -left-32 w-[500px] h-[200px] bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1685917/img/moving_truck_silhouette_left.png)] bg-contain bg-no-repeat blur-3xl opacity-40" />
        <div className="absolute bottom-1/4 -right-32 w-[500px] h-[200px] bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1685917/img/logistics_grid_overlay_right.png)] bg-contain bg-no-repeat blur-3xl opacity-40" />
      </div>

      <div className="container mx-auto px-4 relative z-10">
        <div className={`text-center mb-16 transition-all duration-1000 transform ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <h2 className="font-default text-3xl md:text-5xl font-bold tracking-tight mb-4 uppercase">
            Client Experiences
          </h2>
          <p className="text-muted-foreground text-lg max-w-2xl mx-auto font-default">
            Discover why families and businesses trust SHIFT for their most important moves.
          </p>
        </div>

        <div className={`transition-all duration-1000 delay-200 transform ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
          <Carousel opts={{
          align: "start",
          loop: true
        }} className="w-full max-w-7xl mx-auto">
            <CarouselContent className="-ml-4 md:-ml-6">
              {testimonials.map((testimonial, index) => <CarouselItem key={index} data-index={index} className="pl-4 md:pl-6 md:basis-1/2 lg:basis-1/3">
                  <Card className="bg-card border-border h-full flex flex-col justify-between shadow-lg hover:shadow-xl transition-all duration-300 rounded-md">
                    <CardHeader className="pb-4">
                      <div className="flex gap-1 mb-4">
                        {[...Array(5)].map((_, starIndex) => <Star key={starIndex} data-index={starIndex} className="w-5 h-5 text-primary fill-primary" />)}
                      </div>
                      <CardDescription className="text-foreground/90 text-lg font-serif italic leading-relaxed">
                        "{testimonial.quote}"
                      </CardDescription>
                    </CardHeader>
                    <CardFooter className="pt-4 border-t border-border">
                      <div className="flex flex-col">
                        <span className="font-default font-bold text-lg text-secondary uppercase tracking-tight">
                          {testimonial.author}
                        </span>
                        <span className="font-default text-sm text-primary font-semibold tracking-wider uppercase">
                          {testimonial.car}
                        </span>
                      </div>
                    </CardFooter>
                  </Card>
                </CarouselItem>)}
            </CarouselContent>
            <div className="flex justify-center gap-4 mt-12">
              <CarouselPrevious className="static translate-y-0 translate-x-0 bg-background border-border text-foreground hover:bg-primary hover:text-primary-foreground transition-colors rounded-md" />
              <CarouselNext className="static translate-y-0 translate-x-0 bg-background border-border text-foreground hover:bg-primary hover:text-primary-foreground transition-colors rounded-md" />
            </div>
          </Carousel>
        </div>
      </div>
    </section>;
}